export default __webpack_public_path__ + "static/media/landing_page1.7a0dda9f.svg";